import { createReducer } from 'redux-act';
import * as actions from 'modules/actions';
import { IRequestData } from 'modules/types';

export interface IInvitesReducer extends IRequestData {
	readonly is_data_requested: boolean;
	is_success: boolean;
}

export interface IEmailInvite {
	email: string;
	first_name: string;
}

export interface IEmailInvites {
	league_id: number;
	invites: IEmailInvite[];
}

const initialState = {
	is_data_requested: false,
	is_success: false,
};

export const invite_league = createReducer<IInvitesReducer>({}, initialState)
	.on(actions.inviteViaEmail, () => ({
		...initialState,
		is_data_requested: true,
	}))
	.on(actions.inviteViaEmailSuccess, (_store) => ({
		is_data_requested: false,
		is_success: true,
	}))
	.on(actions.inviteViaEmailClear, () => initialState)
	.on(actions.inviteViaEmailFailed, () => initialState)
;
